// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ui6wr","avatar":"styles_avatar__KrBUs","name":"styles_name__4Jdsp"};